<template>
  <div class="nt-toasts" aria-live="polite">
    <div v-for="toast in toasts" :key="toast.key" class="nt-toast" :class="`nt-toast-${toast.severity || 'info'}`" role="status">
      <i class="fa nt-toast-icon" :class="[icon(toast), `nt-sev-${toast.severity}`]" aria-hidden="true"></i>
      <div class="nt-toast-body" @click="openItem(toast)">
        <strong class="nt-toast-title">{{ toast.title }}</strong>
        <span v-if="toast.body" class="nt-toast-text">{{ toast.body }}</span>
      </div>
      <button class="nt-toast-close" type="button" aria-label="Dismiss" @click="dismiss(toast.key)">×</button>
    </div>
  </div>
</template>

<script>
import { notificationCenter, markNotificationRead, SEVERITY_ICONS } from '../../../utils/notifications'

// A toast for each notification pushed while the user is on any page. Critical ones stay
// until closed; the rest close after a while. Mounted once in index.html.
const VISIBLE_MS = 12000
let seq = 0

export default {
  name: 'notification-toasts',
  data () {
    return { toasts: [] }
  },
  created () {
    notificationCenter.$on('notification', this.show)
  },
  beforeDestroy () {
    notificationCenter.$off('notification', this.show)
  },
  methods: {
    show (notification) {
      const key = `t${++seq}`
      this.toasts.push(Object.assign({}, notification, { key }))
      if (this.toasts.length > 4) this.toasts.shift()
      if (notification.severity !== 'critical') setTimeout(() => this.dismiss(key), VISIBLE_MS)
    },
    dismiss (key) {
      this.toasts = this.toasts.filter(t => t.key !== key)
    },
    openItem (toast) {
      const item = notificationCenter.items.find(n => n.id === toast.id)
      markNotificationRead(item)
      this.dismiss(toast.key)
      if (toast.link) this.$router.push(toast.link)
    },
    icon (toast) {
      return SEVERITY_ICONS[toast.severity] || SEVERITY_ICONS.info
    }
  }
}
</script>

<style scoped>
.nt-toasts { position: fixed; right: 16px; bottom: 16px; z-index: 2000; display: flex; flex-direction: column; gap: 10px; max-width: 380px; }
.nt-toast { display: flex; align-items: flex-start; gap: 10px; padding: 12px 14px; border-radius: 8px; background: #fff; box-shadow: 0 6px 24px rgba(16, 24, 40, 0.18); border-left: 4px solid #0e9488; text-align: left; animation: nt-in 0.2s ease-out; }
.nt-toast-success { border-left-color: #12b76a; }
.nt-toast-warning { border-left-color: #f79009; }
.nt-toast-critical { border-left-color: #d92d20; }
.nt-toast-icon { margin-top: 2px; font-size: 16px; }
.nt-toast-body { flex: 1; display: flex; flex-direction: column; gap: 2px; font-size: 13px; color: #344054; cursor: pointer; }
.nt-toast-title { color: #101828; }
.nt-toast-text { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; max-height: 4.5em; }
.nt-toast-close { border: 0; background: none; font-size: 18px; line-height: 1; color: #98a2b3; cursor: pointer; }
.nt-sev-critical { color: #d92d20; }
.nt-sev-warning { color: #f79009; }
.nt-sev-success { color: #12b76a; }
.nt-sev-info { color: #0e9488; }
@media (max-width: 440px) {
  .nt-toasts { left: 16px; max-width: none; }
}
@keyframes nt-in { from { transform: translateY(8px); opacity: 0; } to { transform: none; opacity: 1; } }
</style>



// WEBPACK FOOTER //
// NotificationToasts.vue?1bfc3e07